import type { PortalEventUrls } from "../../portal/usePortalEventUrls";

export const v1SupplierViewLinkToPortal = (
  eventId: string,
  search: string,
  view: PortalEventUrls["view"],
): string => {
  const params = new URLSearchParams(search);
  const question = params.get("question");
  const announcement = params.get("announcement");

  if (question) return view.question(eventId, question);
  if (announcement) return view.announcement(eventId, announcement);
  return view.go(eventId);
};
